export const ADD_MOVIE_TO_Watchlist ='ADD_MOVIE_TO_Watchlist';
export const REMOVE_MOVIE_FROM_WATCHLIST ='REMOVE_MOVIE_FROM_WATCHLIST';
export const ADD_MOVIE_TO_WATHCED ='ADD_MOVIE_TO_WATHCED'
export const REMOVE_MOVIE_FROM_WATCHED ='REMOVE_MOVIE_FROM_WATCHED'
export const MOVE_TO_WATCHLIST ='MOVE_TO_WATCHLIST';
